import { EST_TIME_ZONE } from '@helpers/utils/asset-price/asset-price';
import { formatInTimeZone } from 'date-fns-tz';

export const TOP_COMPETITORS_LIMIT = 5;
export const TOP_COMPETITORS_ONTOLOGY_VERSION = 'v6' as const;

const REPORTING_DATE_FORMAT = 'yyyy-MM-dd';

export interface CompetitorEarningsSnapshot {
  reportingDate?: string;
  reportingPeriod?: string;
  hasReported?: boolean;
  epsSurprisePct?: number;
  revenueSurprisePct?: number;
  tPlus1Pct?: number;
  tPlus2Pct?: number;
}

export const formatReportingDate = (reportingDate: string) =>
  formatInTimeZone(
    new Date(reportingDate),
    EST_TIME_ZONE,
    REPORTING_DATE_FORMAT
  );

export const pickClosestEarnings = <T extends { reporting_date: string }>(
  earnings: T[],
  reportingDate: string
) => {
  const targetMs = new Date(reportingDate).getTime();

  return earnings.reduce<T | undefined>((closest, earning) => {
    if (!closest) {
      return earning;
    }

    const earningMs = new Date(earning.reporting_date).getTime();
    const closestMs = new Date(closest.reporting_date).getTime();

    return Math.abs(earningMs - targetMs) < Math.abs(closestMs - targetMs)
      ? earning
      : closest;
  }, undefined);
};
